import Tooltip from './Tooltip';
import Component from '../Component';
import classList from '../utils/classList';
import textContrastClass from '../helpers/textContrastClass';
import Icon from './Icon';
/**
 * The `Badge` component represents a user/discussion badge, indicating some
 * status (e.g. a discussion is stickied, a user is an admin).
 *
 * A badge may have the following special attrs:
 *
 * - `type` The type of badge this is. This will be used to give the badge a
 *   class name of `Badge--{type}`.
 * - `icon` The name of an icon to show inside the badge.
 * - `label`
 *
 * All other attrs will be assigned as attributes on the badge element.
 */
export default class Badge extends Component {
  view() {
    const {
      type,
      icon: iconName,
      label,
      color,
      style = {},
      ...attrs
    } = this.attrs;
    const className = classList('Badge', [type && `Badge--${type}`], attrs.className, textContrastClass(color));
    const iconChild = iconName ? m(Icon, {
      name: iconName,
      className: "Badge-icon"
    }) : m.trust('&nbsp;');
    const newStyle = {
      ...style
    };
    if (!window.testing) {
      newStyle['--badge-bg'] = color;
    }
    const badgeAttrs = {
      // A labelled badge is an icon that means something ("Admin", "Sticky"),
      // and its tooltip puts that meaning in `aria-label`. ARIA prohibits
      // `aria-label` on a plain <div>, so screen readers may ignore it; the
      // `img` role makes the label the badge's accessible name.
      role: label ? 'img' : undefined,
      ...attrs,
      className,
      style: newStyle
    };
    const badgeNode = m("div", badgeAttrs, iconChild);

    // If we don't have a tooltip label, don't render the tooltip component.
    if (!label) return badgeNode;
    return m(Tooltip, {
      text: label
    }, badgeNode);
  }
}
flarum.reg.add('core', 'common/components/Badge', Badge);